// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useContext, forwardRef, Fragment, useEffect } from 'react';
import cn from 'classnames';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import hopt from 'hola_opt';
import zurl from '/util/url.js';
import zutil from '/util/util.js';
import { App_context } from '../context.js';
import { use_scrolled } from '../ui_utils.js';
import { Lang_select } from './lang_select.tsx';
import { use_screen } from '../lib/screen_util.ts';
import { Navbar_logo } from './navbar/navbar_logo.js';
import { Search_field } from './navbar/search.js';
import { Zlxc_label } from './navbar/zlxc_label.js';
import { Navbar_menu } from './navbar/navbar_menu.js';
import { Navbar_toggle } from './navbar/navbar_toggle.js';
import './navbar.module.less';
import { Settings_context } from '../settings_ctx';
import { Data_context } from '../data_ctx';
import { use_translation_v } from '../lib/trans_v.tsx';
import { perr } from 'hola_pub_util';
var r_or_call = v => {
  if (typeof v == 'function') return v();
  return v;
};
var Navbar = /*#__PURE__*/forwardRef(function _Navbar(props, ref) {
  var _useContext = useContext(App_context),
    is_portal = _useContext.is_portal,
    is_client = _useContext.is_client,
    env_label = _useContext.env_label;
  var _useContext2 = useContext(Settings_context),
    theme = _useContext2.theme,
    theme_name = _useContext2.theme_name;
  useContext(Data_context);
  var search = props.search,
    host = props.host,
    t_enabled = props.t_enabled,
    r_translation = props.r_translation,
    route = props.route;
  var route_opt = route && r_or_call(route.opt) || {};
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var headlogo = route && r_or_call(route.headlogo);
  var footless = route && r_or_call(route.footless);
  var headless = route && r_or_call(route.headless);
  var nosearch = headlogo && footless || route && r_or_call(route.nosearch);
  var show_search = !nosearch && (pathname != '/' && pathname != '/download_hola' || props.is_portal);
  var _route_opt$navbar = route_opt.navbar,
    navbar = _route_opt$navbar === void 0 ? {} : _route_opt$navbar,
    logo = route_opt.logo,
    logo_cls = route_opt.logo_cls,
    logo_link = route_opt.logo_link,
    navbar_with_lang = route_opt.navbar_with_lang;
  if (theme_name == 'hola2023') logo = 'hola_logo_letters.svg';
  var transparent = navbar.transparent,
    _navbar$search_opt = navbar.search_opt,
    search_opt = _navbar$search_opt === void 0 ? {} : _navbar$search_opt;
  var top_portal_ref = ref.top_portal_ref,
    navbar_portal_ref = ref.navbar_portal_ref;
  var scrolled = use_scrolled((d, y, prev_d, prev_y) => {
    return prev_y > 0 != y > 0 || prev_d != d;
  });
  var inner_props = {
    headlogo,
    headless,
    footless,
    search: show_search && search,
    route_opt
  };
  var _use_screen = use_screen(),
    width = _use_screen.width;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    toggled = _useState2[0],
    set_toggled = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    menu_opened = _useState4[0],
    menu_toggle = _useState4[1];
  var result_direction = 'down';
  if (scrolled.direction == 'up' && scrolled.count > 1) result_direction = 'up';
  var dark = host == 'holavpn.com' && ['/', '/stream_sports'].includes(pathname);
  var cls = cn('container-fluid navbar', navbar.cls, transparent && 'navbar--transparent', toggled && 'opened', navbar_with_lang && 'with_lang', scrolled.y > 0 && 'navbar-scrolled', scrolled.y > 0 && `navbar-scrolled-${result_direction}`, is_portal && 'portal', headlogo && 'only-logo', show_search && search && search.filter && 'filtered', 'navbar_pg-' + (pathname.replace(/^.*\//, '') || 'hp'));
  var on_toggle = () => set_toggled(!toggled);
  var on_logo_click = () => {
    if (pathname == '/') window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  };
  var qs_o = zurl.qs_parse(location.search.substr(1), {
    safe: true
  });
  var url_ref = qs_o.ref || '';
  var hide_header_conf = zutil.get(hopt, 'www_hola.hide_header_by_ref') || [];
  var hide_header = hide_header_conf.includes(url_ref);
  useTranslation();
  var _use_translation_v = use_translation_v(),
    t = _use_translation_v.t;
  var r_title = t('health_check');
  useEffect(() => {
    if (r_title == 'health_check') perr({
      id: 'www_hola_no_db_trans_detected'
    });
  }, []);
  if (headless) return /*#__PURE__*/React.createElement(Fragment, null);
  var navbar_cls = cn(theme.root, cls, {
    'menu-opened': menu_opened,
    'hola2023': theme_name == 'hola2023'
  });
  return /*#__PURE__*/React.createElement("div", {
    className: navbar_cls
  }, /*#__PURE__*/React.createElement("div", {
    className: "top-portal",
    ref: top_portal_ref
  }), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "navbar-header"
  }, /*#__PURE__*/React.createElement(Navbar_logo, {
    on_click: on_logo_click,
    dark: theme_name == 'dark' || dark || route_opt.dark,
    logo: logo,
    logo_cls: logo_cls,
    to: logo_link
  }), !headlogo && is_client && env_label && /*#__PURE__*/React.createElement(Zlxc_label, {
    label: env_label
  }), !headlogo && /*#__PURE__*/React.createElement(Navbar_toggle, {
    on_toggle: on_toggle,
    toggled: toggled
  })), !hide_header && /*#__PURE__*/React.createElement("div", {
    className: "navbar-portal",
    ref: navbar_portal_ref
  }, show_search && search && width > 991 && /*#__PURE__*/React.createElement(Search_field, _extends({}, search, {
    popup: true
  }, search_opt))), !headlogo && /*#__PURE__*/React.createElement(Navbar_menu, _extends({}, props, inner_props, {
    hide_header: hide_header,
    menu_toggle: menu_toggle,
    toggled: toggled,
    set_toggled: set_toggled
  })), t_enabled && /*#__PURE__*/React.createElement(Lang_select, {
    r_translation: r_translation
  })));
});
export { Navbar };